"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DefaultTheme = void 0;
var Themes = [require('./Blackout.json'), require('./Whites.json'), require('./Blues.json'), require('./Warm'), require('./Go.json'), require('./Muted.json')];
var DefaultTheme = Themes.find(function (item) {
  return item.id === 'default';
});
exports.DefaultTheme = DefaultTheme;
var _default = Themes;
exports["default"] = _default;



//////////////////
// WEBPACK FOOTER
// ../handball-libs/libs/pounder-themes/index.js
// module id = 329
// module chunks = 0